/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 9.3.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BikeNetwork
 */
export interface BikeNetwork {
  /**
   *
   * @type {boolean}
   * @memberof BikeNetwork
   */
  mountain?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BikeNetwork
   */
  local?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BikeNetwork
   */
  regional?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BikeNetwork
   */
  national?: boolean;
}

/**
 * Check if a given object implements the BikeNetwork interface.
 */
export function instanceOfBikeNetwork(value: object): value is BikeNetwork {
  return true;
}

export function BikeNetworkFromJSON(json: any): BikeNetwork {
  return BikeNetworkFromJSONTyped(json, false);
}

export function BikeNetworkFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BikeNetwork {
  if (json == null) {
    return json;
  }
  return {
    mountain: json["mountain"] == null ? undefined : json["mountain"],
    local: json["local"] == null ? undefined : json["local"],
    regional: json["regional"] == null ? undefined : json["regional"],
    national: json["national"] == null ? undefined : json["national"],
  };
}

export function BikeNetworkToJSON(json: any): BikeNetwork {
  return BikeNetworkToJSONTyped(json, false);
}

export function BikeNetworkToJSONTyped(
  value?: BikeNetwork | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    mountain: value["mountain"],
    local: value["local"],
    regional: value["regional"],
    national: value["national"],
  };
}
